import React, { Component } from 'react';

import _ from 'i18n';
import { ucFirst, isArraysEqual } from 'utils';
import Email from './email/Email';
import { connect } from "react-redux";
import { SVG_ICONS } from "Common";
import { SVG_VALID_ICON, SVG_WARNING_ICON } from "../../../services/svgIcones";

@connect(store => ({
  userLng: store.params.lng,
}))
export default class TypeEmails extends Component {

  copiedTimeoutId = null;

  state = {
    copied: false,
  };

  componentWillUnmount() {
    clearTimeout(this.copiedTimeoutId);
  }

  handleCopyCode = (e) => {
    e.stopPropagation();
    const code = `${this.props.type.id || ""}`;
    const done = () => {
      this.setState({ copied: true });
      clearTimeout(this.copiedTimeoutId);
      this.copiedTimeoutId = setTimeout(() => this.setState({ copied: false }), 1500);
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done, () => {});
    } else {
      // Fallback for browsers without the async clipboard API.
      const textarea = document.createElement("textarea");
      textarea.value = code;
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand("copy");
        done();
      } catch (err) {
        /* no-op */
      }
      document.body.removeChild(textarea);
    }
  };

  handleEdit = (e) => {
    e.stopPropagation();
    const { onEdit, type } = this.props;
    if (onEdit) {
      onEdit(type);
    }
  };

  handleDelete = (e) => {
    e.stopPropagation();
    const { onDelete, type } = this.props;
    if (onDelete) {
      onDelete(type);
    }
  };

  render() {
    const { languages, type, emails, active, onToggleActive, userLng } = this.props;
    const { copied } = this.state;
    const activeLanguages = Object.keys(emails) || [];
    const label = type[`label${ucFirst(userLng)}`];
    const emptyType = !isArraysEqual(activeLanguages, languages);

    return (
      <div id={type.id} className="generic-email-container">
        <div className={`generic-email-header row ${(emptyType && type.required) && 'alert'}`}>
          <div className="generic-email-header__title">
            {emptyType ? SVG_WARNING_ICON : SVG_VALID_ICON}
            <h4 className="text-capitalize">{label}</h4>
          </div>
          <div className="generic-email-header__right-side">
            <span className="languages">
              {activeLanguages.map(lng => <img key={`${type.id}-${lng}`} src={`/img/flags/${lng}.svg`} />)}
            </span>
            <span className="type-actions">
              <button
                type="button"
                className={`type-actions__btn ${copied ? "is-copied" : ""}`}
                data-tip={copied ? _("code_copied") : `${_("copy_code")} (${type.id})`}
                onClick={this.handleCopyCode}
              >
                {copied ? (
                  <span className="type-actions__check">{SVG_VALID_ICON}</span>
                ) : (
                  <img src={"/img/icons/" + SVG_ICONS["COPY"]} alt="" />
                )}
              </button>
              <button
                type="button"
                className="type-actions__btn"
                data-tip={_("edit")}
                onClick={this.handleEdit}
              >
                <img src={"/img/icons/" + SVG_ICONS["PENCIL"]} alt="" />
              </button>
              <button
                type="button"
                className="type-actions__btn type-actions__btn--danger"
                data-tip={_("delete")}
                onClick={this.handleDelete}
              >
                <img src={"/img/icons/" + SVG_ICONS["TRASH"]} alt="" />
              </button>
            </span>
            <span className="icon" onClick={onToggleActive}>
              <i className={`${(active) ? 'icon-arrow-up' : 'icon-arrow-down'}`} />
            </span>
          </div>
        </div>
        <div className={`generic-email-list ${active && 'generic-email-list__open'} row`}>
          {
            languages.map(lng => (
              <Email
                key={`email-${emails[lng] ? emails[lng].id : "empty-" + lng}`}
                item={(emails && emails[lng]) ? emails[lng] : { language: lng, targetType: type.id }}
                isUAVersion={this.props.isUAVersion}
              />
            ))
          }
        </div>
      </div>
    );
  }
}
